import { render, staticRenderFns } from "./totalSearch.vue?vue&type=template&id=c9cf1ff2&"
import script from "./totalSearch.vue?vue&type=script&lang=js&"
export * from "./totalSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports